/**
 * Delay time before close autocomplete.
 *
 * (This prevent autocomplete DOM get detroyed before access data.)
 */
export const AUTOCOMPLETE_CLOSE_DELAY = 250;

/**
 * Allowed attributes that can be passed to internal input.
 */
export const ALLOWED_ATTRS = [
	'autofocus',
	'disabled',
	'form',
	'id',
	'inputmode',
	'list',
	'maxlength',
	'minlength',
	'name',
	'pattern',
	'placeholder',
	'readonly',
	'required',
	'required',
	'size',
	'spellcheck',
	'tabindex',
	'title'
];
